import { useCallback } from "react";

export default function useHasOrganizationRole({ organization, user }) {
	return useCallback(
		(...roles) => roles.some((role) => user?.permissions?.[organization.type]?.[organization.id]?.includes(role)),
		[organization.id, organization.type, user?.permissions],
	);
}
